import { Building2, Facebook, Globe, Instagram, Mail, MessageCircle, MessageSquareText, Phone, Users } from "lucide-react";

const ICONS = {
  "Página web": Globe, Web: Globe, WhatsApp: MessageCircle, Instagram, Facebook, Correo: Mail, SMS: MessageSquareText,
  Teléfono: Phone, Referido: Users, Presencial: Building2,
};

export const ChannelIcon = ({ channel, className = "h-4 w-4" }) => {
  const Icon = ICONS[channel] || MessageCircle;
  return <Icon className={className} aria-hidden="true" />;
};
